import { DtcFaultDescriptionsResponseItem, DtcSourceDescriptionResponse } from '@eagle/core-data-types';
import { createContext, FC, PropsWithChildren, useContext } from 'react';

interface BatchFaultDataContextValue {
  faultDescriptions: Record<number, DtcFaultDescriptionsResponseItem | null>;
  sourceDescriptions: Record<number, DtcSourceDescriptionResponse | null>;
  isLoading: boolean;
}

const BatchFaultDataContext = createContext<BatchFaultDataContextValue | null>(null);

export const BatchFaultDataProvider: FC<PropsWithChildren<{ faultDescriptions: Record<number, DtcFaultDescriptionsResponseItem | null>; sourceDescriptions: Record<number, DtcSourceDescriptionResponse | null>; isLoading: boolean }>> = ({ children, faultDescriptions, sourceDescriptions, isLoading }) => {
  return (
    <BatchFaultDataContext.Provider value={{ faultDescriptions, sourceDescriptions, isLoading }}>
      {children}
    </BatchFaultDataContext.Provider>
  );
};

export const useBatchFaultData = (): BatchFaultDataContextValue => {
  const context = useContext(BatchFaultDataContext);
  if (!context) {
    throw new Error('useBatchFaultData must be used within BatchFaultDataProvider');
  }
  return context;
};

export const useBatchFaultDataSafe = (): BatchFaultDataContextValue | null => {
  return useContext(BatchFaultDataContext);
};
